import { useState, useEffect, useCallback } from 'react';
import { TooltipState } from '@components/Tooltip/typescript';
const useTooltip = () => {
  const [tooltipState, setTooltipState] = useState<TooltipState>({
    isVisible: false,
    content: '',
    position: {
      x: 0,
      y: 0
    },
    targetElement: null
  });
  const showTooltip = useCallback((element: HTMLElement, content: string) => {
    const rect = element.getBoundingClientRect();
    setTooltipState({
      isVisible: true,
      content,
      position: {
        x: rect.left + rect.width / 2,
        y: rect.top
      },
      targetElement: element
    });
  }, []);
  const hideTooltip = useCallback(() => {
    setTooltipState(prev => ({
      ...prev,
      isVisible: false
    }));
  }, []);
  useEffect(() => {
    const handleMouseEnter = (event: MouseEvent) => {
      const target = event.target as Node;

      // Znajdź najbliższy element HTML z atrybutem tooltip-data
      let element: HTMLElement | null = null;
      if (target instanceof HTMLElement) {
        element = target;
      } else if (target.parentElement) {
        element = target.parentElement;
      }

      // Sprawdź czy element lub jego rodzice mają tooltip-data
      while (element && !element.getAttribute('tooltip-data')) {
        element = element.parentElement;
      }
      if (element) {
        const tooltipData = element.getAttribute('tooltip-data');
        if (tooltipData) {
          showTooltip(element, tooltipData);
        }
      }
    };
    const handleMouseLeave = (event: MouseEvent) => {
      const target = event.target as Node;

      // Znajdź najbliższy element HTML z atrybutem tooltip-data
      let element: HTMLElement | null = null;
      if (target instanceof HTMLElement) {
        element = target;
      } else if (target.parentElement) {
        element = target.parentElement;
      }

      // Sprawdź czy element lub jego rodzice mają tooltip-data
      while (element && !element.getAttribute('tooltip-data')) {
        element = element.parentElement;
      }
      if (element) {
        const tooltipData = element.getAttribute('tooltip-data');
        if (tooltipData) {
          hideTooltip();
        }
      }
    };
    const handleScroll = () => {
      if (tooltipState.isVisible) {
        hideTooltip();
      }
    };
    const handleResize = () => {
      if (tooltipState.isVisible) {
        hideTooltip();
      }
    };

    // Dodaj event listenery do całego dokumentu
    document.addEventListener('mouseenter', handleMouseEnter, true);
    document.addEventListener('mouseleave', handleMouseLeave, true);
    document.addEventListener('scroll', handleScroll, true);
    window.addEventListener('resize', handleResize);
    return () => {
      document.removeEventListener('mouseenter', handleMouseEnter, true);
      document.removeEventListener('mouseleave', handleMouseLeave, true);
      document.removeEventListener('scroll', handleScroll, true);
      window.removeEventListener('resize', handleResize);
    };
  }, [showTooltip, hideTooltip, tooltipState.isVisible]);
  return {
    tooltipState,
    showTooltip,
    hideTooltip
  };
};
export default useTooltip;